module.exports = __webpack_public_path__ + "static/media/loan-income.1f9d2318.svg";